import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

/**
 * 다른 기기/브라우저에서 로그인이 감지되면 request.js의 triggerForceLogout()이
 * 'agms:force-logout' 이벤트를 발생시킨다. 그때 이 모달을 띄우고,
 * 확인 시 로그인 화면으로 이동한다. (기존 alert 대체)
 */
const ForceLogoutDialog = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("agms:force-logout", handler);
    return () => window.removeEventListener("agms:force-logout", handler);
  }, []);

  const handleConfirm = () => {
    setOpen(false);
    window.location.href = "/login";
  };

  return (
    <Dialog open={open} onClose={handleConfirm} maxWidth="xs" fullWidth>
      <DialogTitle>접속 종료</DialogTitle>
      <DialogContent>
        <DialogContentText>
          다른 곳에서 로그인하여 접속이 종료됩니다.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleConfirm} autoFocus>
          확인
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ForceLogoutDialog;
